import React from 'react';
import './button.css';

type ButtonVariant = 'primary' | 'secondary' | 'quiet' | 'destructive' | 'success' | 'warning' | 'gradient' | 'glass';
type ButtonSize = 'sm' | 'md' | 'lg';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  fullWidth?: boolean;
  pulse?: boolean;
};

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  fullWidth = false,
  pulse = false,
  className = '',
  children,
  disabled,
  ...rest
}) => {
  const classes = [
    'ui-btn',
    `ui-btn--${variant}`,
    `ui-btn--${size}`,
    fullWidth ? 'ui-btn--full-width' : '',
    pulse ? 'ui-btn--pulse' : '',
    isLoading ? 'ui-btn--loading' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      className={classes}
      disabled={disabled || isLoading}
      {...rest}
    >
      {isLoading && (
        <span className="ui-btn__spinner" aria-hidden>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" strokeOpacity="0.25" />
            <path d="M12 2a10 10 0 0 1 10 10" strokeLinecap="round" />
          </svg>
        </span>
      )}
      {leftIcon && <span className="ui-btn__icon ui-btn__icon--left" aria-hidden>{leftIcon}</span>}
      <span className="ui-btn__label">{children}</span>
      {rightIcon && <span className="ui-btn__icon ui-btn__icon--right" aria-hidden>{rightIcon}</span>}
    </button>
  );
};

export default Button;


